import type { PhaseType, PhaseFormType } from 'entities/phases'

export const transformPhaseToReq = (phase: PhaseType | PhaseFormType) => {
    if (!phase) {
        return null
    }

    return {
        ...phase,
        numberOfPlayoffTeams: phase.numberOfPlayoffTeams
            ? phase.numberOfPlayoffTeams
            : 2,
    }
}
